<template>
	<div>
		<ul class="right-menu">
			<!-- <router-link v-for="(item,index) in secondMenulist" :key="index" active-class="secondnav-active" :to="idtopath(item)"> -->
			<li
				v-for="(item,index) in secondMenulist" :key="index" @mouseenter="enter(index,item)" @mouseleave="leave(index,item)"	@click="idtopath(index,item)">
				<p :class="nowSelectModule.funcname == item.funcname ?'secondnav-active':''">
					<img class="circle" src="../../../static/images/head/图层图标-深色.png">
					{{item.funcname}}
				</p>
			</li>
			<!-- </router-link> -->
		</ul>
	</div>
</template>

<script>
import { getRolepagebypid } from "@/apis/api";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      menulist: null
    };
  },

  methods: {
    ...mapMutations(["CHANGESECONDMODULE", "CHANGENOWOPTBRESOURCEID"]),
    enter(index, data) {
      $(".right-menu>li").eq(index).children("p").addClass("hover-active");
    },
    leave(index, data) {
      $(".right-menu>li").eq(index).children("p").removeClass("hover-active");
    },
    idtopath(index, data) {
      sessionStorage.setItem("indeX", index);
      sessionStorage.setItem("clickIndex", '');
      sessionStorage.setItem("data1", JSON.stringify(data));
      if (!data) return;
      this.CHANGESECONDMODULE(data);
      this.CHANGENOWOPTBRESOURCEID(data.resourceid);
      $(".right-menu>li").eq(index).children("p").addClass("secondnav-active").children("img").attr("src", "../../../static/images/head/图层图标-白色.png");
      $(".right-menu>li").eq(index).siblings("li").children("p").removeClass("secondnav-active").children("img").attr("src", "../../../static/images/head/图层图标-深色.png");
      if (data.moduletype == "formdata") {
        //通用表单
        this.$router.push({
          path: "/main/have/formlist",
          name: "formlist",
          params: {
            menudata: JSON.stringify(data)
          }
        });
      } else if (data.moduletype == "custom") {
        //自定义界面
        if (data.funcname == "关系曲线拟合") {
          this.$router.push({
            path: "/main/have/fittingcalculation",
            name: "fittingcalculation",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "逐日流量统计") {
          this.$router.push({
            path: "/main/have/statistical",
            name: "statistical",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        //              }else if(data.funcname == '排水渠道情况') {
        //                  this.$router.push({path:'/main/have/paishuiqudao',name:'paishuiqudao',params:{menudata:this.userInfo.regioncode}});
        } else if (data.funcname == "简介") {
          this.$router.push({
            path: "/main/have/guanqujianjie",
            name: "guanqujianjie",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "推算流量") {
          this.$router.push({
            path: "/main/have/ziliaozhengbian",
            name: "ziliaozhengbian",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "原始报文") {
          this.$router.push({
            path: "/main/have/originalmessage",
            name: "originalmessage",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "水位报警") {
          this.$router.push({
            path: "/main/have/wateralarm",
            name: "wateralarm",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "推流记录") {
          this.$router.push({
            path: "/main/have/zhengbianchaxun",
            name: "zhengbianchaxun",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "逐日水位统计") {
          this.$router.push({
            path: "/main/have/zhurishuiwei",
            name: "zhurishuiwei",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "水位日报表") {
          this.$router.push({
            path: "/main/have/shuiweiribaobiao",
            name: "shuiweiribaobiao",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "水位定制日报表") {
          this.$router.push({
            path: "/main/have/waterleveldaily",
            name: "waterleveldaily",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "流量定制月报表") {
          this.$router.push({
            path: "/main/have/monthlytrafficreport",
            name: "monthlytrafficreport",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "多站流量水位报表") {
          this.$router.push({
            path: "/main/have/multistationflowlevelreport",
            name: "multistationflowlevelreport",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "检索图片查询") {
          this.$router.push({
            path: "/main/have/detectpicturequery",
            name: "detectpicturequery",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "实时配出合成报表") {
          this.$router.push({
            path: "/main/have/realtimematchingreport",
            name: "realtimematchingreport",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "逐日平均流量合成表") {
          this.$router.push({
            path: "/main/have/dailyflowsynthesistable",
            name: "dailyflowsynthesistable",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "逐日流量初整表") {
          this.$router.push({
            path: "/main/have/dailyaverageflowmeterchuzheng",
            name: "dailyaverageflowmeterchuzheng",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "逐日流量整编表") {
          this.$router.push({
            path: "/main/have/dailyaverageflowmeter",
            name: "dailyaverageflowmeter",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "逐日平均水量表") {
          this.$router.push({
            path: "/main/have/dailyaveragewatervolume",
            name: "dailyaveragewatervolume",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "拟合计算") {
          this.$router.push({
            path: "/main/have/fittingcalculation",
            name: "fittingcalculation",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "数据录入") {
          this.$router.push({
            path: "/main/have/dataentry",
            name: "dataentry",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "数据录入（肯斯瓦特）") {
          this.$router.push({
            path: "/main/have/dataentryKSWT",
            name: "dataentryKSWT",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "对照表导入") {
          this.$router.push({
            path: "/main/have/nihedaoru",
            name: "nihedaoru",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "实测流量成果表") {
          this.$router.push({
            path: "/main/have/resultsOfMeasuredDischarge",
            name: "resultsOfMeasuredDischarge",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "水位月报表") {
          this.$router.push({
            path: "/main/have/shuiweiyuebaobiao",
            name: "shuiweiyuebaobiao",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "流量日报表") {
          this.$router.push({
            path: "/main/have/liuliangribaobiao",
            name: "liuliangribaobiao",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "流量月报表") {
          this.$router.push({
            path: "/main/have/liuliangyuebaobiao",
            name: "liuliangyuebaobiao",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "水位流量数据检索") {
          this.$router.push({
            path: "/main/have/shuiweijiansuo",
            name: "shuiweijiansuo",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "水位流量数据（肯斯瓦特）") {
          this.$router.push({
            path: "/main/have/shuiweijiansuokswt",
            name: "shuiweijiansuokswt",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "水位流量过程线") {
          this.$router.push({
            path: "/main/have/shuiweiliuliangguochengxian",
            name: "shuiweiliuliangguochengxian",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "雨量日报表") {
          this.$router.push({
            path: "/main/have/yuliangribaobiao",
            name: "yuliangribaobiao",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "雨量月报表") {
          this.$router.push({
            path: "/main/have/yuliangyuebaobiao",
            name: "yuliangyuebaobiao",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "逐日降雨量统计") {
          this.$router.push({
            path: "/main/have/zhurijiangyuliang",
            name: "zhurijiangyuliang",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "月雨量直方图") {
          this.$router.push({
            path: "/main/have/yueyuliangzft",
            name: "yueyuliangzft",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "日雨量直方图") {
          this.$router.push({
            path: "/main/have/riyuliangzft",
            name: "riyuliangzft",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "多站雨量直方图") {
          this.$router.push({
            path: "/main/have/duozhanyuliangzft",
            name: "duozhanyuliangzft",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "多站水位过程线") {
          this.$router.push({
            path: "/main/have/duozhanshuiweigcx",
            name: "duozhanshuiweigcx",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "曲线管理") {
          this.$router.push({
            path: "/main/have/fittingquery",
            name: "fittingquery",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "测点信息管理") {
          this.$router.push({
            path: "/main/have/stationmanagement",
            name: "stationmanagement",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "实时水情信息") {
          this.$router.push({
            path: "/main/have/shishishuiqingxinxi",
            name: "shishishuiqingxinxi",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "综合实时数据") {
          this.$router.push({
            path: "/main/have/realtimedata",
            name: "realtimedata",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "实时雨情信息") {
          this.$router.push({
            path: "/main/have/shishiyuqingxinxi",
            name: "shishiyuqingxinxi",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "用户角色设置") {
          this.$router.push({
            path: "/main/have/userroleset",
            name: "userroleset",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "测流计算") {
          this.$router.push({
            path: "/main/have/fittingdischarge",
            name: "fittingdischarge",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "测流计算校核") {
          this.$router.push({
            path: "/main/have/fittingflow",
            name: "fittingflow",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "巡查详情") {
          this.$router.push({
            path: "/main/have/patroldetail",
            name: "patroldetail",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "巡查历史") {
          this.$router.push({
            path: "/main/have/patrolhistory",
            name: "patrolhistory",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "巡查任务分配") {
          this.$router.push({
            path: "/main/have/patroltaskallocation",
            name: "patroltaskallocation",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "停水处理") {
          this.$router.push({
            path: "/main/have/waterstopmanager",
            name: "waterstopmanager",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "停水记录") {
          this.$router.push({
            path: "/main/have/waterstopquery",
            name: "waterstopquery",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else if (data.funcname == "单价管理") {
          // 防止 URL 自动跳转
          // if(!this.$route.matched.some(item => item.name === 'waterfee-pricing')){
          this.$router.push({
            path: "/main/have/waterfee-pricing/period-search"
          });
          // }
        } else if (data.funcname == "缴费管理") {
          this.$router.push({
            name: "waterfee-payment-search",
            params: {
              menudata: this.userInfo.regioncode
            }
          });
        } else {
          this.$router.push({
            path: "/main/have/error404",
            name: "404"
          });
        }
      } else if (data.moduletype == "tab") {
        //主副从表
        this.$router.push({
          path: "main/have/tablist",
          name: "tablist",
          params: {
            menudata: JSON.stringify(data)
          }
        });
      }
    }
  },
  created() {
    var _this = this;
  },
  mounted() {
    setTimeout(()=>{
    var data = JSON.parse(sessionStorage.getItem("data1"));
    var index = JSON.parse(sessionStorage.getItem("indeX"));
    console.log(data,index,'iiiiiiiiiii')
    if(index){
    	this.idtopath(index, data)
    }
    }, 100);
  },
  computed: {
    ...mapState(["userInfo", "secondMenulist", "nowSelectModule"])
  },
  watch: {
    $route(to, from) {}
  }
};
</script>

<style lang='less' scoped>
//二级菜单选中样式
.right-menu {
  list-style: none;
  /*overflow: auto;*/
  li {
    height: 50px;
    cursor: pointer;
    position: relative;
    p {
      width: 90%;
      height: 40px;
      /*margin-top: 15px;
				margin-left: 10%;*/
      line-height: 40px;
      border-radius: 20px;
      position: absolute;
      top: 5px;
      left: 5%;
    }
    .circle {
      display: inline-block;
      width: 10px;
      height: 10px;
      /*background-image:url(../../../static/images/head/图层图标-深色.png);*/
      border-radius: 50%;
      margin: 0 20px;
    }
    /*.tubiao{
				background-image:url(../../../static/images/head/图层图标-白色.png);
			}*/
  }
}

.secondnav-active {
  background: #398fe6;
  color: #fff;
}
.hover-active {
  background: #d8e9fb;
}
</style>



// WEBPACK FOOTER //
// src/components/mainInterface/nav-left.vue